import React from 'react'
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'

export function ListsCreateWith() {
    const name = "lists_create_with";
    ListsCreateWith.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}></block>
    );
}

export function ListsRepeat() {
    const name = "lists_repeat";
    ListsRepeat.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}>
            <value name="NUM">
                <shadow type="math_whole_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>
    );
}

export function ListsLength() {
    const name = "lists_length";
    ListsLength.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}></block>
    );
}

export function ListsIsEmpty() {
    const name = "lists_isEmpty";
    ListsIsEmpty.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}></block>
    );
}

export function ListsIndexOf() {
    const name = "lists_indexOf";
    ListsIndexOf.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}>
            <value name="VALUE"></value>
        </block>
    );
}

export function ListsGetIndex() {
    const name = "lists_getIndex";
    ListsGetIndex.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}>
            <value name="AT">
                <shadow type="math_whole_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    );
}

export function ListsGetSublist() {
    const name = "lists_getSublist";
    ListsGetSublist.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}>
            <value name="AT1">
                <shadow type="math_whole_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>

            <value name="AT2">
                <shadow type="math_whole_number">
                    <field name="NUM">3</field>
                </shadow>
            </value>

        </block>
    );
}

export function ListsSplit() {
    const name = "lists_split";
    ListsSplit.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}>
            <value name="DELIM">
                <shadow type="text">
                    <field name="TEXT">,</field>
                </shadow>
            </value>
        </block>
    );
}

export function ListsSort() {
    const name = "lists_sort";
    ListsSort.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");
    
    return (
        <block type={name}></block>
    );
}